import template from './calculator.page.html';
import controller from './calculator.page.controller';
import './calculator.page.scss';

let calculatorPageComponent = {
  bindings: {
    fields : '=',
    pageTitle: '<',
    type: '<',
    page: '<',
    goNext: '&',
    goBack: '&',
    allFields : '=',
    matterType: '<'
  },
  template,
  controller
};

export default calculatorPageComponent;



// WEBPACK FOOTER //
// ./client/app/components/calculator/calculator.page/calculator.page.component.js